var _mask, _path, _mask2, _path2, _mask3, _path3, _mask4, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "cross_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.9 1.93 2.33.53l21.21 21.2-1.41 1.42L.9 1.93z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.9 1.93-.5.53l-1.42 1.4 1.41 1.42L.91 1.93zM2.33.53 3.73-.9 2.32-2.31.91-.89 2.32.52zm21.21 21.2 1.42 1.42 1.41-1.42-1.41-1.41-1.42 1.41zm-1.41 1.42-1.41 1.41 1.4 1.42 1.42-1.42-1.41-1.41zM2.32 3.35l1.41-1.42L.91-.89-.51.52l2.83 2.83zM.91 1.93l21.2 21.22 2.84-2.83L3.73-.89.91 1.93zm21.2 18.39-1.4 1.41 2.82 2.83 1.42-1.41-2.83-2.83zm1.42 1.41L2.32.53-.51 3.34l21.22 21.21 2.82-2.83z",
    fill: "currentColor",
    mask: "url(#cross_svg__a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "cross_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.9 41.52 1.42 1.42 21.21-21.22-1.41-1.41L.9 41.52z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m.9 41.52-1.4 1.42-1.42-1.42 1.41-1.41 1.42 1.41zm1.42 1.42 1.41 1.41-1.41 1.41-1.41-1.41 1.41-1.41zm21.21-21.22 1.42-1.41 1.41 1.41-1.41 1.42-1.42-1.42zm-1.41-1.41-1.41-1.42 1.4-1.41 1.42 1.41-1.41 1.42zM2.32 40.1l1.41 1.41-2.82 2.83-1.42-1.41 2.83-2.83zM.91 41.52l21.2-21.21 2.84 2.83L3.73 44.35.91 41.52zm21.2-18.38-1.4-1.42 2.82-2.83 1.42 1.42-2.83 2.83zm1.42-1.42L2.32 42.94-.51 40.1l21.22-21.22 2.82 2.83z",
    fill: "currentColor",
    mask: "url(#cross_svg__b)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "cross_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 1.93 41.59.53l-21.22 21.2 1.42 1.42L43 1.93z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m43 1.93 1.41-1.4 1.42 1.4-1.42 1.42L43 1.93zM41.59.53 40.17-.9l1.42-1.42L43-.89 41.59.52zm-21.22 21.2-1.41 1.42-1.42-1.42 1.42-1.41 1.41 1.41zm1.42 1.42 1.41 1.41-1.41 1.42-1.42-1.42 1.42-1.41zm19.8-19.8-1.42-1.42L43-.89 44.41.52 41.6 3.35zM43 1.93 21.79 23.15l-2.83-2.83L40.17-.89 43 1.93zM21.79 20.32l1.41 1.41-2.83 2.83-1.41-1.41 2.83-2.83zm-1.42 1.41L41.6.53l2.82 2.82-21.2 21.21-2.84-2.83z",
    fill: "currentColor",
    mask: "url(#cross_svg__c)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "cross_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43 41.52-1.41 1.42-21.22-21.22 1.42-1.41L43 41.52z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m43 41.52 1.41 1.42 1.42-1.42-1.42-1.41L43 41.52zm-1.41 1.42-1.42 1.41 1.42 1.41L43 44.35l-1.41-1.41zM20.37 21.72l-1.41-1.41-1.42 1.41 1.42 1.42 1.41-1.42zm1.42-1.41 1.41-1.42-1.41-1.41-1.42 1.41 1.42 1.42zm19.8 19.8-1.42 1.41L43 44.35l1.41-1.41-2.82-2.83zM43 41.52 21.79 20.31l-2.83 2.83 21.21 21.21L43 41.52zM21.79 23.14l1.41-1.42-2.83-2.83-1.41 1.42 2.83 2.83zm-1.42-1.42L41.6 42.94l2.82-2.83-21.2-21.22-2.84 2.83z",
    fill: "currentColor",
    mask: "url(#cross_svg__d)"
  })));
};
export default SvgCross;